import { render, staticRenderFns } from "./NameElement.vue?vue&type=template&id=4beacc2a&"
import script from "./NameElement.vue?vue&type=script&lang=js&"
export * from "./NameElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports